import { MojoServiceTypes } from "lib/GetClientConfig"
import { createContext, useContext } from "react"
import { PaymentStatus } from "models/ApplicationSummaryEnhanced"

export interface RecommendationContextProps {
  serviceType: MojoServiceTypes
  paymentStatus: PaymentStatus | undefined
  setPaymentStatus: (status: PaymentStatus | undefined) => void
  isBtlSpecialist: boolean
  friendlyId: string
}

export const RecommendationContext = createContext<RecommendationContextProps>({
  serviceType: MojoServiceTypes.DEFAULT,
  paymentStatus: undefined,
  setPaymentStatus: () => ({}),
  isBtlSpecialist: false,
  friendlyId: "",
})

export const useRecommendationContext = () => useContext(RecommendationContext)
